<script lang="ts">
  import ChevronDown32 from "carbon-icons-svelte/lib/ChevronDown32";
  import DateInputWithPicker from "@cohesionib/biblioteca/lib/DateInputWithPicker";
  import { today } from "@cohesionib/biblioteca/lib/util/dates";
  import { format, isSameDay } from "date-fns";

  export let startDate: Date = today;
  export let endDate: Date = today;
  export let isLoading: boolean = false;
  export let error: string = null;
  export let includeWeekends: boolean = false;

  let pickerStartDate: Date = today;
  let pickerEndDate: Date = today;
  let weekendsIncluded: boolean = false;

  const formatDate = (date: Date) =>
    format(date, "MMMM do', 'yyyy'").replaceAll(".", "");

  $: dateTitle = isSameDay(startDate, endDate)
    ? formatDate(startDate)
    : `${formatDate(startDate)} - ${formatDate(endDate)}`;

  let isOpen = false;

  let onApply = () => {
    isOpen = false;
    startDate = pickerStartDate;
    endDate = pickerEndDate;
    isLoading = true;
    error = null;
    includeWeekends = weekendsIncluded;
  };
  let onCancel = () => {
    isOpen = false;
    pickerStartDate = startDate;
    pickerEndDate = endDate;
    weekendsIncluded = includeWeekends;
  };
  let onOpen = () => {
    isOpen = true;
  };
</script>

<style>
  #modal-wrapper {
    position: absolute;
    top: 2.5rem;
    z-index: 2;
  }
  #transparent-background {
    z-index: 0;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
  }
  #date-title-row {
    position: relative;
    display: flex;
    font-size: 1em;
    font-weight: 100;
  }
  #date-title {
    font-size: 1.5em;
    color: #4e4e4e;
    font-weight: 400;
    padding: 0 0.5em;
  }
  #chevron {
    cursor: pointer;
  }
</style>

<div>
  <div id="date-title-row">
    <div id="date-title">{dateTitle}</div>
    <div id="modal-container">
      <div id="chevron" on:click={onOpen}>
        <ChevronDown32 />
      </div>
      {#if isOpen}
        <div on:click={onCancel} id="transparent-background" />
        <div id="modal-wrapper">
          <DateInputWithPicker
            onApply={pickerStartDate ? onApply : () => {}}
            {onCancel}
            isDateRange={true}
            bind:startDateValue={pickerStartDate}
            bind:endDateValue={pickerEndDate}
            markedDates={[new Date()]}
            disableFuture={true}
            bind:includeWeekends={weekendsIncluded}
          />
        </div>
      {/if}
    </div>
  </div>
</div>
